var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 4H12.75C12.75 3.00544 12.3549 2.05161 11.6517 1.34835C10.9484 0.645088 9.99456 0.25 9 0.25C8.00544 0.25 7.05161 0.645088 6.34835 1.34835C5.64509 2.05161 5.25 3.00544 5.25 4H2.125C1.79348 4 1.47554 4.1317 1.24112 4.36612C1.0067 4.60054 0.875 4.91848 0.875 5.25V14.625C0.875 14.9565 1.0067 15.2745 1.24112 15.5089C1.47554 15.7433 1.79348 15.875 2.125 15.875H15.875C16.2065 15.875 16.5245 15.7433 16.7589 15.5089C16.9933 15.2745 17.125 14.9565 17.125 14.625V5.25C17.125 4.91848 16.9933 4.60054 16.7589 4.36612C16.5245 4.1317 16.2065 4 15.875 4ZM9 1.5C9.66304 1.5 10.2989 1.76339 10.7678 2.23223C11.2366 2.70107 11.5 3.33696 11.5 4H6.5C6.5 3.33696 6.76339 2.70107 7.23223 2.23223C7.70107 1.76339 8.33696 1.5 9 1.5Z",
    fill: "#7E5C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/Professional.0b39c2719151bc9e5deefcb75ac35e82.svg";
export { ForwardRef as ReactComponent };